document.addEventListener("DOMContentLoaded", function () {
  const locationContainer = document.querySelector(".opt-location");
  const colorBlockOriginal = document.querySelector(".opt-number_of_color");
  const uploadOriginal = document.querySelector('[class^="ai-art-upload-"]');

  if (!locationContainer || !colorBlockOriginal) return;

  /* ---------------- Config (same as the old upload block) ---------------- */
  const UPLOAD_API = "https://ghost.appsdroplogicx.uk/api/shopify/upload-file";
  const API_ORIGIN = "https://ghost.appsdroplogicx.uk";
  const SHOP = (window.Shopify && Shopify.shop) || "ghostprintlab.myshopify.com";
  const MAX_SIZE = 20 * 1024 * 1024;
  const ALLOWED = ["png", "jpg", "jpeg", "pdf", "svg"];
  const IMAGE_EXT = ["png", "jpg", "jpeg", "svg"];
  const STORE_KEY = "enquiry_artworks";

  /* ---------------- Templates ---------------- */
  const colorBlockTemplate = colorBlockOriginal.cloneNode(true);
  colorBlockOriginal.style.display = "none";

  // Take markup only (NOT cloneNode) so the old custom element's JS doesn't run again
  let P = "";
  let uploadHTML = "";
  if (uploadOriginal) {
    P = uploadOriginal.className.split(" ")[0];
    uploadHTML = uploadOriginal.innerHTML;
    uploadOriginal.style.display = "none";
  }

  const anchor =
    locationContainer.querySelector(".ai-radio-options") ||
    document.querySelector(".ai-radio-options") ||
    locationContainer;

  /* ---------------- State ---------------- */
  // artworks[location] = { status: 'uploading'|'done'|'error', name, url, pct, objectUrl, ext, xhr, msg }
  const artworks = {};
  let inFlight = 0;

  // start clean on every page load
  try {
    localStorage.removeItem("enquiry_artwork_url");
    localStorage.removeItem("enquiry_artwork_name");
    localStorage.setItem(STORE_KEY, "{}");
  } catch (e) {}
  window.artworkUploading = false;

  function persist() {
    const out = {};
    Object.keys(artworks).forEach((loc) => {
      const a = artworks[loc];
      if (a.status === "done") out[loc] = { url: a.url, name: a.name };
    });
    try { localStorage.setItem(STORE_KEY, JSON.stringify(out)); } catch (e) {}
  }

  function slugify(text) {
    return text.toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]/g, "");
  }

  const getUrl = (data) => {
    if (typeof data === "string") data = { url: data.trim() };
    let url =
      data?.url || data?.data?.url || data?.file?.url || data?.data?.file?.url ||
      data?.files?.[0]?.url || data?.data?.files?.[0]?.url ||
      data?.cdn_url || data?.data?.cdn_url || data?.image_url || data?.data?.image_url ||
      data?.path || data?.data?.path || data?.link || data?.data?.link ||
      data?.file_url || data?.data?.file_url || "";
    if (url && !/^https?:\/\//i.test(url)) {
      url = API_ORIGIN + (url.startsWith("/") ? "" : "/") + url;
    }
    return url;
  };

  /* ---------------- Color blocks (your original logic) ---------------- */
  function generateColorBlock(locationName, savedValue) {
    const clone = colorBlockTemplate.cloneNode(true);
    clone.style.display = "block";
    clone.classList.add("generated-color-block");

    const slug = slugify(locationName);
    const inputName = `properties[Number of color - ${locationName}]`;
    const inputName2 = `Number of color - ${locationName}`;

    const title = clone.querySelector(".cu-ai-radio-options__title");
    if (title) title.innerHTML = `Select Number of Colors (<strong>${locationName}</strong>)`;

    const radios = clone.querySelectorAll('input[type="radio"]');
    const labels = clone.querySelectorAll("label");

    radios.forEach((radio, index) => {
      const uniqueId = `color-${slug}-${index + 1}`;
      radio.name = inputName;
      radio.id = uniqueId;
      radio.checked = false;
      if (labels[index]) {
        labels[index].setAttribute("for", uniqueId);
        labels[index].setAttribute("data-product-option-val", inputName2);
      }
    });

    const saved = savedValue && [...radios].find((r) => r.value === savedValue);
    (saved || radios[0]).checked = true;
    return clone;
  }

  /* ---------------- Upload blocks ---------------- */
  const q = (w, s) => w.querySelector("." + P + "__" + s);

  function findUploadBlock(loc) {
    return [...document.querySelectorAll(".generated-upload-block")].find(
      (el) => el.dataset.location === loc
    );
  }

  function generateUploadBlock(loc) {
    const wrap = document.createElement("div");
    wrap.className = P + " generated-upload-block";
    wrap.dataset.location = loc;
    wrap.innerHTML = uploadHTML;

    const uid = "ArtworkUpload-" + slugify(loc);
    const label = q(wrap, "label");
    const input = wrap.querySelector('input[type="file"]');
    label.setAttribute("for", uid);
    label.innerHTML = `Upload artwork (<strong>${loc}</strong>) <span class="${P}__required" aria-hidden="true">*</span>`;
    input.id = uid;
    input.required = true;
    input.setAttribute("aria-label", `Upload artwork for ${loc}. Required. Drop a file here or activate to browse.`);

    const zone = q(wrap, "dropzone");

    input.addEventListener("change", () => handleFiles(loc, input.files));
    q(wrap, "remove").addEventListener("click", () => removeArtwork(loc));

    ["dragenter", "dragover"].forEach((n) =>
      zone.addEventListener(n, (e) => { e.preventDefault(); zone.classList.add("is-dragging"); })
    );
    ["dragleave", "drop"].forEach((n) =>
      zone.addEventListener(n, (e) => { e.preventDefault(); zone.classList.remove("is-dragging"); })
    );
    zone.addEventListener("drop", (e) => {
      if (!e.dataTransfer || !e.dataTransfer.files.length) return;
      input.files = e.dataTransfer.files;
      handleFiles(loc, e.dataTransfer.files);
    });

    return wrap;
  }

  function render(loc) {
    const w = findUploadBlock(loc);
    if (!w) return;
    const zone = q(w, "dropzone"), status = q(w, "filename"), prog = q(w, "progress"),
          bar = q(w, "progress-bar"), prev = q(w, "preview"), thumbWrap = q(w, "thumb-wrap"),
          pname = q(w, "preview-name");
    const s = artworks[loc];

    status.className = P + "__filename";
    status.textContent = "";
    zone.classList.remove("is-busy");
    prog.classList.remove("is-visible");
    prev.classList.remove("is-visible");
    thumbWrap.textContent = "";
    if (!s) return;

    if (s.status === "error") {
      status.textContent = s.msg;
      status.classList.add("is-error");
      return;
    }

    // preview
    if (IMAGE_EXT.includes(s.ext) && (s.objectUrl || s.url)) {
      const img = document.createElement("img");
      img.className = P + "__thumb";
      img.alt = "Preview of " + s.name;
      img.src = s.objectUrl || s.url;
      thumbWrap.appendChild(img);
    } else {
      const box = document.createElement("div");
      box.className = P + "__thumb-file";
      box.textContent = s.ext.toUpperCase();
      thumbWrap.appendChild(box);
    }
    pname.textContent = s.name;
    prev.classList.add("is-visible");

    if (s.status === "uploading") {
      zone.classList.add("is-busy");
      prog.classList.add("is-visible");
      bar.style.width = s.pct + "%";
      status.textContent = `Uploading ${s.name}... ${Math.round(s.pct)}%`;
    } else {
      status.textContent = "✓ " + s.name + " uploaded";
      status.classList.add("is-success");
    }
  }

  function renderProgress(loc) {
    const w = findUploadBlock(loc);
    const s = artworks[loc];
    if (!w || !s) return;
    q(w, "progress-bar").style.width = s.pct + "%";
    q(w, "filename").textContent = `Uploading ${s.name}... ${Math.round(s.pct)}%`;
  }

  function clearArtwork(loc) {
    const a = artworks[loc];
    if (!a) return;
    if (a.xhr) { try { a.xhr.abort(); } catch (e) {} if (a.status === "uploading") inFlight--; }
    if (a.objectUrl) URL.revokeObjectURL(a.objectUrl);
    delete artworks[loc];
    window.artworkUploading = inFlight > 0;
  }

  function removeArtwork(loc) {
    clearArtwork(loc);
    const w = findUploadBlock(loc);
    if (w) q(w, "input").value = "";
    persist();
    render(loc);
  }

  function setError(loc, msg) {
    clearArtwork(loc);
    artworks[loc] = { status: "error", msg };
    const w = findUploadBlock(loc);
    if (w) q(w, "input").value = "";
    persist();
    render(loc);
  }

  function handleFiles(loc, files) {
    if (!files || !files.length) return;
    const file = files[0];
    const ext = (file.name.split(".").pop() || "").toLowerCase();
    if (!ALLOWED.includes(ext)) return setError(loc, "Unsupported file type. Use PNG, JPG, PDF or SVG.");
    if (file.size > MAX_SIZE) return setError(loc, "File too large (max 20MB).");
    upload(loc, file, ext);
  }

  function upload(loc, file, ext) {
    clearArtwork(loc);

    const state = {
      status: "uploading", name: file.name, ext, pct: 0, url: "",
      objectUrl: IMAGE_EXT.includes(ext) ? URL.createObjectURL(file) : null,
    };
    artworks[loc] = state;
    inFlight++;
    window.artworkUploading = true;
    persist();
    render(loc);

    const fd = new FormData();
    fd.append("file", file, file.name);
    fd.append("shop", SHOP);

    const xhr = new XMLHttpRequest();
    state.xhr = xhr;

    const finish = () => { inFlight = Math.max(0, inFlight - 1); window.artworkUploading = inFlight > 0; };
    const fail = (msg) => {
      if (artworks[loc] !== state) return;
      finish();
      state.xhr = null;
      setError(loc, msg || "Upload failed, please try again.");
    };

    xhr.upload.addEventListener("progress", (e) => {
      if (!e.lengthComputable || artworks[loc] !== state) return;
      state.pct = Math.min(99, (e.loaded / e.total) * 100);
      renderProgress(loc);
    });

    xhr.addEventListener("load", () => {
      if (artworks[loc] !== state) return; // replaced/removed meanwhile
      if (xhr.status < 200 || xhr.status >= 300) return fail();
      let data;
      try { data = JSON.parse(xhr.responseText); } catch (e) { data = xhr.responseText; }
      const url = getUrl(data);
      if (!url) return fail();

      finish();
      state.xhr = null;
      state.url = url;
      state.pct = 100;
      state.status = "done";
      persist();
      render(loc);
    });

    xhr.addEventListener("error", () => fail());
    xhr.addEventListener("timeout", () => fail("Upload timed out, please try again."));
    xhr.timeout = 120000;
    xhr.open("POST", UPLOAD_API);
    xhr.send(fd);
  }

  /* ---------------- Render per-location blocks ---------------- */
  function selectedLocations() {
    return [...locationContainer.querySelectorAll('input[type="checkbox"]:checked')].map((cb) => cb.value);
  }

  function renderBlocks() {
    // remember chosen colour counts
    const savedColors = {};
    document.querySelectorAll(".generated-color-block input[type='radio']:checked").forEach((r) => {
      savedColors[r.name] = r.value;
    });

    document.querySelectorAll(".generated-color-block, .generated-upload-block").forEach((el) => el.remove());

    let insertAfter = anchor;
    selectedLocations().forEach((loc) => {
      const colorBlock = generateColorBlock(loc, savedColors[`properties[Number of color - ${loc}]`]);
      insertAfter.insertAdjacentElement("afterend", colorBlock);
      insertAfter = colorBlock;

      if (uploadHTML) {
        const up = generateUploadBlock(loc);
        insertAfter.insertAdjacentElement("afterend", up);
        insertAfter = up;
        render(loc); // restore existing upload state / preview
      }
    });
  }

  /* ---------------- Public helpers for the Enquire button ---------------- */
  window.getLocationArtworks = function () {
    return selectedLocations()
      .filter((loc) => artworks[loc] && artworks[loc].status === "done")
      .map((loc) => ({ location: loc, url: artworks[loc].url, name: artworks[loc].name }));
  };

  window.validateLocationArtworks = function () {
    const locs = selectedLocations();
    if (!locs.length) return { ok: false, message: "Please select at least one print location." };

    if (window.artworkUploading) {
      return { ok: false, message: "Your artwork is still uploading. Please wait a moment and try again." };
    }

    const missing = locs.filter((loc) => !(artworks[loc] && artworks[loc].status === "done"));
    if (missing.length) {
      missing.forEach((loc) => {
        if (!artworks[loc] || artworks[loc].status === "error") {
          artworks[loc] = { status: "error", msg: "Artwork is required for this location." };
        }
        render(loc);
      });
      const first = findUploadBlock(missing[0]);
      if (first) first.scrollIntoView({ behavior: "smooth", block: "center" });
      return { ok: false, message: "Please upload artwork for: " + missing.join(", ") };
    }
    return { ok: true };
  };

  /* ---------------- Init ---------------- */
  const checkboxes = locationContainer.querySelectorAll('input[type="checkbox"]');
  checkboxes.forEach((cb) => (cb.checked = false));
  if (checkboxes.length > 0) checkboxes[0].checked = true;

  checkboxes.forEach((cb) => cb.addEventListener("change", renderBlocks));
  renderBlocks();
});